import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PayrollDetailEditModeSearchSchema } from '../../-shared/payroll-detail-edit-mode-search-schema';
import { PayrollStructureDetailLayoutContent } from './-components/PayrollStructureDetailLayoutContent';
export const Route = createFileRoute('/_staff/payroll-engine-mock/_layout/payroll-structures/$structureId/_layout')({
  // 編集状態を持つ Provider は `_layout` 側にあるため、初期モードの検索パラメータも
  // ここで受ける（子タブから読めるように）。
  validateSearch: zodValidator(PayrollDetailEditModeSearchSchema),
  component: PayrollStructureDetailLayoutContent
});